import * as fs from 'fs';
import * as ko from "knockout";
import { MainViewModel } from "../../main";
import { RNSAPI } from "../../api";
import './fastcaseperson';

// Fragen:
//  - was sind die erweiterten Daten
//  - wie entferne ich einen Mandaten wieder
//  - Anrede und Rechtsform wählbar, aber Anrede hängt von Rechtsform ab
//  - Die Buttons zur Addition von weiteren Gegner und die zum Ausklappen sehen alle gleich aus
//  - Warum sind Gegner optional, wenn sie für die Kollisionsprüfung wichtig sind
//
//  Notiz_Mandantenbegehren
//  Notiz_Sachverhalt
//  Notizen


class FastCaseViewModel {
    clients: KnockoutObservableArray<Person> = ko.observableArray([
        {
            personType: ko.observable("mandant"),
            isFirst: ko.observable(true),
            isShown: ko.observable(true),
            isError: ko.observable(false),
            isExtended: ko.observable(false),
            data: createPersonObservable()
        }
    ]);

    defendants: KnockoutObservableArray<Person> = ko.observableArray([
        {
            personType: ko.observable("gegner"),
            isFirst: ko.observable(true),
            isShown: ko.observable(false),
            isError: ko.observable(false),
            isExtended: ko.observable(false),
            data: createPersonObservable()
        }
    ]);

    mandantenbegehren = ko.observable("");
    notizen           = ko.observable("");
    sachverhalt       = ko.observable("");
    registernummer    = ko.observable("");

    modalTitle = ko.observable("");
    modalKeys = ko.observableArray([]);
    modalColumns = ko.observableArray([]);
    modalData = ko.observableArray([]);
    modalHandleSelection: KnockoutObservable<(selectedObject: any) => void> = ko.observable();

    collision: KnockoutObservable<Collision> = ko.observable(CollisionOff);

    closeCollision(): void {
        this.collision(CollisionOff);
    }

    async myCheckCollision() {
        let clients = this.clients();
        let defendants= this.defendants();
        let clientsPeople: string[] = [];
        let defendandtsPeople: string[] = [];
        let clientsCollisions = [];
        let defendantsCollisions = [];

        for (let i = 0; i < defendants.length; i++) {
            if (!defendants[i].data.Name1()) {
                 defendants[i].isShown(true);
                 defendants[i].isError(true);
                document.getElementById('defendant-last-name-' +i).scrollIntoView()
                $('#defendant-last-name-' +i).parent().addClass('has-error');
                setTimeout(() => $('#defendant-last-name-' +i).parent().removeClass('has-error'), 1500);
                return;
            } else {
                defendants[i].isError(false);
                defendandtsPeople.push(ko.toJS(defendants[i].data.Name1));
            }
        }

        for (let i = 0; i < clients.length; i++) {
            if (!clients[i].data.Name1()) {
                clients[i].isShown(true);
                clients[i].isError(true);
                document.getElementById('client-last-name-' +i).scrollIntoView()
                $('#client-last-name-' +i).parent().addClass('has-error');
                setTimeout(() => $('#client-last-name-' +i).parent().removeClass('has-error'), 1500);
                return;
            } else {
                clients[i].isError(false);
                clientsPeople.push(ko.toJS(clients[i].data.Name1));
            }
        }

        this.collision(CollisionLoading);

        for (let lastName of defendandtsPeople) {
            let collisions = await RNSAPI.checkCollision(lastName)
            defendantsCollisions = defendantsCollisions.concat(collisions.Payload.Addresses[0]);
        }

        for (let lastName of clientsPeople) {
            let collisions = await RNSAPI.checkCollision(lastName)
            clientsCollisions = clientsCollisions.concat(collisions.Payload.Addresses[1]);
        }

        for(let client of clients){
          for( let defen of defendants){
            if (client.data.Name1() === defen.data.Name1()){
              defendantsCollisions.push({
                FirstName: defen.data.FirstName(),
                Name1: defen.data.Name1(),
                Address: "",
                ZipCode: "",
                CityName: "",
              });
            }
          }
        }


        this.collision({
            kind: "CollisionLoaded",
            clients: ko.observableArray(clientsCollisions),
            defendants: ko.observableArray(defendantsCollisions)
        });
    }

    

    async pickGeneric(title, keys, columns, data, callback) {
        this.modalTitle(title);
        this.modalKeys(keys);
        this.modalColumns(columns);
        this.modalData(data);
        this.modalHandleSelection(callback);
    };

    addPerson(personType) {
        let array = personType === 'mandant' ? this.clients : this.defendants;
        array.push({
            personType: ko.observable(personType),
            isFirst: ko.observable(false),
            isShown: ko.observable(true),
            isError: ko.observable(false),
            isExtended: ko.observable(false),
            data: createPersonObservable()
        });
    }

    deleteDefendant(index: number): void {
      this.defendants.remove(this.defendants()[index]);
    }

    deleteClient(index: number): void {
      this.clients.remove(this.clients()[index]);
    }

    async postData() {
        let caseData = {
          Registernummer: this.registernummer(),
          Rubrum: createRubrum(this.clients()[0].data.Name1(),this.defendants()[0].data.Name1())
        };
        let addresses = [
            ko.toJS(this.clients).map(p => p.data),
            ko.toJS(this.defendants).map(p => p.data),
            [],
            [],
            [],
            [],
            [],
            [],
            []
        ];
        let extendedCase = {
            Key: this.registernummer(),
            Infos: {
                Notiz_Mandantenbegehren: this.mandantenbegehren(),
                Notiz_Sachverhalt: this.sachverhalt(),
                Notizen: this.notizen()
            },
            Persons: [],
        }

        let data = {
            Akte: caseData,
            Addresses: addresses,
            ExtendedPersons: [],
            ExtendedCase: extendedCase
        };

        /*
        let result = await RNSAPI.createExtendedCase(data).then(
            //() => { MainViewModel.RoutingTable.showCaseOverview(); }
            () => { MainViewModel.RoutingTable.showExtendedMainView({ caseId: caseData.Registernummer }); }
        );
        */
        
        let result = await RNSAPI.createExtendedCase(data);
        if(result.Type === "CaseCreationError") {
            alert("Fehler: Die Akte konnte nicht angelegt werden.");
            this.suggestRegisterNumber();
            return 
        } else {
            MainViewModel.RoutingTable.showExtendedMainView({ caseId: caseData.Registernummer });
        }
            //() => { MainViewModel.RoutingTable.showCaseOverview(); }
            //() => {  }
    }

    constructor(params) {
        params = params || {};
        
        this.suggestRegisterNumber();
    }

    async suggestRegisterNumber() {
        let xregisternummer = (await RNSAPI.suggestCaseId()).Payload.CaseId;
        this.registernummer(xregisternummer);
    }
}

function createRubrum(clientName: string, defendantName: string): string {
  if (clientName && defendantName)
    return (clientName +" ./. " + defendantName ).substring(0,64);
  else
    return clientName.substring(0,64)
}

function isSamePerson(localPerson: any, serverPerson: any): boolean {
  return (localPerson.data.Name1() + localPerson.data.FirstName()).substring(0,20) === serverPerson.Keyword;
}

function createPersonObservable(): any {
    let obj = {
        FirstName: ko.observable(null),
        Name1: ko.observable(null),
        Rechtsform: ko.observable(null),
        Address: ko.observable(null),
        ZipCode: ko.observable(null),
        CityName: ko.observable(null),
        EmailAddress: ko.observable(null),
        Phone1: ko.observable(null),
        edit: ko.observable(true),
        IsSelected: ko.observable(false)
    };

    obj["Keyword"] = ko.computed(() =>
        (obj.Name1() || '') + (obj.FirstName() || ''));

    return obj;
}

export interface Person {
    personType: any,
    isFirst: any,
    isShown: any,
    isError: any,
    isExtended: any,
    data: any,
}

type Collision = CollisionOff | CollisionLoading | CollisionLoaded;

interface CollisionOff {
    kind: "CollisionOff";
}

let CollisionOff: CollisionOff = { kind: "CollisionOff" };

interface CollisionLoading {
    kind: "CollisionLoading";
}

let CollisionLoading: CollisionLoading = { kind: "CollisionLoading" };

interface CollisionLoaded {
    kind:       "CollisionLoaded";
    clients:    any;
    defendants: any;
}

let html = fs.readFileSync(__dirname + '/fastcase.html', 'utf8');

ko.components.register("fastcase-view", {
    viewModel: FastCaseViewModel,
    template: html
});
